import { Link } from "@tanstack/react-router";
import { cn } from "@/lib/utils";

interface MedicalReviewProps {
  lang?: "en" | "es";
  className?: string;
}

export function MedicalReviewBanner({ lang = "en", className }: MedicalReviewProps) {
  const copy = {
    en: {
      text: "Accuracy of the medical content was verified by ",
      name: "Dr. Matthew Fitzer, M.D., FACS, FASMBS",
      suffix: ", a board-certified bariatric surgeon. (He authored most of it.)",
      link: "/about",
      label: "Read Dr. Fitzer's professional bio",
    },
    es: {
      text: "La exactitud del contenido médico fue verificada por el ",
      name: "Dr. Matthew Fitzer, M.D., FACS, FASMBS",
      suffix: ", cirujano bariátrico certificado por la junta americana. (Él escribió la mayor parte.)",
      link: "/es/sobre-el-doctor",
      label: "Leer la biografía profesional del Dr. Fitzer",
    },
  }[lang];

  return (
    <p
      className={cn(
        "rounded-lg border border-brand bg-brand-soft px-4 py-3 text-sm text-brand-deep",
        className
      )}
    >
      {copy.text}
      <Link to={copy.link} className="font-semibold underline hover:no-underline">
        {copy.name}
      </Link>
      {copy.suffix}
      <span className="sr-only"> {copy.label}</span>
    </p>
  );
}

